export const get = (url: string) => fetch(`/api${url}`).then((res) => res.json())

export const post = (url: string, data: {} = {}) => fetch(`/api${url}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
}).then(res => res.json())